import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "bankIcons",
	standalone: true
})
export class BankIconsPipe implements PipeTransform {
	transform(value: string): string {
		if (value === "ASAAS") {
			return "assets/icons/banks/icon-asaas-extrato.svg";
		}

		return "assets/icons/banks/icon-bancos-extrato.svg";
	}
}
